module.exports = __webpack_public_path__ + "img/NU.c0487ff1.png";